/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_BuildInputs */

const en_mk_nav_build = /** @type {(inputs: Mk_Nav_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your app`)
};

const id_mk_nav_build = /** @type {(inputs: Mk_Nav_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun aplikasi`)
};

/**
* | output |
* | --- |
* | "Build your app" |
*
* @param {Mk_Nav_BuildInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_build = /** @type {((inputs?: Mk_Nav_BuildInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_BuildInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_build(inputs)
	return en_mk_nav_build(inputs)
});